import { type IconProps, Icon } from "@chakra-ui/icon";

const QrCodeIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_7869_18392)">
				<path
					opacity="0.4"
					d="M2.00667 8.49967H2M5.34 11.833H5.33333M8.00667 14.4997H8M14.0067 8.49967H14M10.3333 8.49967H11.6667M2 11.833H3M2 14.4997H5.33333M8 1.83301V5.83301"
					stroke="black"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.66667 8.5H8V11.8333M11.7333 14.5H12.9333C13.3067 14.5 13.4934 14.5 13.636 14.4273C13.7614 14.3634 13.8634 14.2614 13.9273 14.136C14 13.9934 14 13.8067 14 13.4333V12.2333C14 11.86 14 11.6733 13.9273 11.5307C13.8634 11.4052 13.7614 11.3032 13.636 11.2393C13.4934 11.1667 13.3067 11.1667 12.9333 11.1667H11.7333C11.36 11.1667 11.1733 11.1667 11.0307 11.2393C10.9052 11.3032 10.8032 11.4052 10.7393 11.5307C10.6667 11.6733 10.6667 11.86 10.6667 12.2333V13.4333C10.6667 13.8067 10.6667 13.9934 10.7393 14.136C10.8032 14.2614 10.9052 14.3634 11.0307 14.4273C11.1733 14.5 11.36 14.5 11.7333 14.5ZM11.7333 5.83333H12.9333C13.3067 5.83333 13.4934 5.83333 13.636 5.76067C13.7614 5.69676 13.8634 5.59477 13.9273 5.46933C14 5.32672 14 5.14004 14 4.76667V3.56667C14 3.1933 14 3.00661 13.9273 2.86401C13.8634 2.73856 13.7614 2.63658 13.636 2.57266C13.4934 2.5 13.3067 2.5 12.9333 2.5H11.7333C11.36 2.5 11.1733 2.5 11.0307 2.57266C10.9052 2.63658 10.8032 2.73856 10.7393 2.86401C10.6667 3.00661 10.6667 3.1933 10.6667 3.56667V4.76667C10.6667 5.14004 10.6667 5.32672 10.7393 5.46933C10.8032 5.59477 10.9052 5.69676 11.0307 5.76067C11.1733 5.83333 11.36 5.83333 11.7333 5.83333ZM3.06667 5.83333H4.26667C4.64004 5.83333 4.82672 5.83333 4.96933 5.76067C5.09477 5.69676 5.19676 5.59477 5.26067 5.46933C5.33333 5.32672 5.33333 5.14004 5.33333 4.76667V3.56667C5.33333 3.1933 5.33333 3.00661 5.26067 2.86401C5.19676 2.73856 5.09477 2.63658 4.96933 2.57266C4.82672 2.5 4.64004 2.5 4.26667 2.5H3.06667C2.6933 2.5 2.50661 2.5 2.36401 2.57266C2.23856 2.63658 2.13658 2.73856 2.07266 2.86401C2 3.00661 2 3.1933 2 3.56667V4.76667C2 5.14004 2 5.32672 2.07266 5.46933C2.13658 5.59477 2.23856 5.69676 2.36401 5.76067C2.50661 5.83333 2.6933 5.83333 3.06667 5.83333Z"
					stroke="#334155"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7869_18392">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</Icon>
	);
};

export default QrCodeIcon;
